import React from 'react';

const formatTime = (iso) => {
    if (!iso) return '';
    const d = new Date(iso.replace(' ', 'T'));
    const now = new Date();
    const diffMs = now - d;
    const diffMin = diffMs / 60000;
    if (diffMin < 1) return 'now';
    if (diffMin < 60) return `${Math.floor(diffMin)}m`;
    if (diffMin < 1440) return `${Math.floor(diffMin / 60)}h`;
    if (diffMin < 10080) return `${Math.floor(diffMin / 1440)}d`;
    return d.toLocaleDateString('en-GB', { day: '2-digit', month: 'short' });
};

const ChatSidebar = ({ conversations, activeThreadId, onSelect, onNewChat, myId }) => {
    return (
        <aside className="skc-chat-sidebar">
            <div className="skc-chat-sidebar-top">
                <input
                    className="skc-chat-search"
                    placeholder="Search conversations…"
                    onChange={(e) => {
                        // optional: client-side filter
                    }}
                />
                <button className="skc-chat-new-btn" onClick={onNewChat} title="New chat">
                    +
                </button>
            </div>

            <div className="skc-chat-list">
                {conversations.length === 0 && (
                    <div className="skc-chat-list-empty">
                        <p>No conversations yet</p>
                        <button className="skc-chat-list-empty-btn" onClick={onNewChat}>
                            Start a new chat
                        </button>
                    </div>
                )}

                {conversations.map((c) => {
                    const isActive = activeThreadId === c.thread_id;
                    const other = c.thread_type === 'dm'
                        ? c.members.find(m => m.id !== myId)
                        : null;
                    const displayName = c.title || (other ? other.name : 'Group');
                    const avatarLetter = (displayName || '?').charAt(0).toUpperCase();

                    return (
                        <button
                            key={c.thread_id}
                            className={`skc-chat-list-item ${isActive ? 'is-active' : ''} ${c.unread_count > 0 ? 'has-unread' : ''}`}
                            onClick={() => onSelect(c)}
                        >
                            <div className="skc-chat-avatar">
                                {other?.image ? (
                                    <img src={other.image} alt={displayName} />
                                ) : (
                                    <span>{avatarLetter}</span>
                                )}
                                {c.thread_type === 'group' && (
                                    <span className="skc-chat-avatar-group-icon">👥</span>
                                )}
                            </div>

                            <div className="skc-chat-list-meta">
                                <div className="skc-chat-list-row">
                                    <span className="skc-chat-list-name">{displayName}</span>
                                    <span className="skc-chat-list-time">{formatTime(c.last_message_at)}</span>
                                </div>
                                <div className="skc-chat-list-row">
                                    <span className="skc-chat-list-preview">{c.last_message_body || ''}</span>
                                    {c.unread_count > 0 && (
                                        <span className="skc-chat-list-badge">
                                            {c.unread_count > 99 ? '99+' : c.unread_count}
                                        </span>
                                    )}
                                </div>
                            </div>
                        </button>
                    );
                })}
            </div>
        </aside>
    );
};

export default ChatSidebar;